<!--test.vue-->
<template>
  <div class="qk-image">
    <!-- crossOrigin='anonymous'供图片裁剪使用 -->
    <img :class="getFit(fit)" :src="getSrc(imageSrc)" alt="" crossOrigin='anonymous'/>
  </div>
</template>

<script>
  export default {
    name: 'QkImage', // 这个名字很重要，它就是未来的标签名<qk-text></qk-text>
    props: {
      imageSrc: {
        type: String,
        default: ''
      },
      fit: {
        type: String,
        default: 'cover'
      }
    },
    methods: {
      getSrc(imageSrc) {
        if (imageSrc.indexOf('base64,') != -1) {
          return imageSrc
        }
        // return imageSrc + '?v=' + new Date().getTime()
        return imageSrc
      },
      getFit(fit) {
        if (fit == 'cover') {
          return 'img-cover'
        }
        if (fit == 'contain') {
          return 'img-contain'
        }
        return 'img-default'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .qk-image{
    width: 100%;
    height: 100%;
  }
  .img-cover{
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .img-contain {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .img-default {
    display: block;
    width: 100%;
    height: 100%;
  }
</style>
